<template>
  <!-- Render elements dynamically -->
  <ComponentWrapper
      v-for="item in elements"
      :key="item.props.key"
      :item="item"
  >
    <!-- Recursively render children -->
    <ElementRenderer :elements="item.children"/>
  </ComponentWrapper>
</template>

<script setup lang="ts">
import {defineProps } from 'vue';
import ComponentWrapper from "./ComponentWrapper.vue";
import type {Component} from "../types";

const { elements } = defineProps<{
  elements: Component[]
}>();
</script>
